import * as React from 'react';
import { cn } from '~/lib/utils';
import { useFormField } from './form';
import { Input } from './input';
export interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}
const FormInput = React.forwardRef<HTMLInputElement, FormInputProps>(({
  className,
  ...props
}, ref) => {
  const {
    error
  } = useFormField();
  return <Input ref={ref} {...props} className={cn(className, {
    'border-destructive': error !== undefined
  })} />;
});
FormInput.displayName = 'FormInput';
export { FormInput };